<template>
    <div>
        <b-modal size="xl" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar">

            <b-form @submit.prevent="save">
                <b-card>
                    <b-form-row>
                        <lg-form-input invalidFeedback="Informe uma descrição válida!" description=" "
                            :error="$v.form.descricao" v-model="form.descricao" label="Descrição:*" cols="12" />
                    </b-form-row>

                    <b-form-row>
                        <LgFinderPageProduto :disabled="produto != null" id="finderProduto"
                            @onselect="handleSelectProduto" v-model="form.produto" label="Produto:*"
                            :prefix="prefix + title + '>'" />

                    </b-form-row>

                    <b-form-row>
                        <b-form-group label="Status:" class="ml-3">
                            <b-form-radio-group v-model="form.situacao" :options="statusOptions" size="sm"
                                name="status-inline"></b-form-radio-group>
                        </b-form-group>
                    </b-form-row>


                    <b-form-row>

                        <b-col cols="3"></b-col>
                        <b-col cols="6" class="text-center">
                            <b-button id="salvar" class=" my-2" size="sm" pill variant="success" @click="save">
                                <b-icon icon="check-circle" />
                                <b-tooltip target="salvar" title="Salvar"></b-tooltip>

                            </b-button>

                            <b-button id="cancelar" class=" my-2 ml-2" size="sm" pill variant="danger"
                                @click="cancelar">
                                <b-icon icon="x-circle" />
                                <b-tooltip target="cancelar" title="Cancelar"></b-tooltip>

                            </b-button>
                        </b-col>
                        <b-col cols="3"></b-col>

                    </b-form-row>


                </b-card>
            </b-form>
        </b-modal>
    </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import ResourceService from "@/core/api/ResourceService";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { FormResourceMixin } from "@/core/mixins/resource";
import LgFinderPageProduto from "@/components/Finders/LgFinderPageProduto.vue";
export default {
    components: {
        LgFormInput,
        LgFinderPageProduto
    },
    mixins: [FormResourceMixin],
    validations: {
        form: {
            descricao: { required },
            situacao: { required },
            produto: { required }
        },
    },
    props: {
        produto: Object,

        almoxarifado: {
            type: Boolean,
            default: false,
        },

        id: Number,
        prefix: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            form: {
                produto: this.produto ? this.produto : {},
                descricao: "",
                situacao: 1,
            },
            showModal: true,
            statusOptions: [
                { text: "Ativo", value: 1 },
                { text: "Inativo", value: 0 },
            ],
            title: "Cadastro",


        };
    },
    async beforeMount() {
        if (this.almoxarifado) {
            this.$service = new ResourceService(`/api/especificacao-produto-almoxarifado`)
        } else {
            this.$service = new ResourceService(`/api/especificacao-produto`)
        }
    },
    async mounted() {
        if (this.id) {
            const { data } = await this.$service.findById(this.id);
            this.form = data;
        } else {
            this.form.situacao = 1;
        }
    },
    methods: {
        handleSelectProduto(produto) {
            this.form.produto = produto
        },

        async save() {
            if (!this.formIsValid) {
                this.$v.$touch();
                this.$notify({
                    type: "danger",
                    message: "Verifique os campos do cadastro.",
                });
                return;
            }

            await this.$saveResource(this.form);
            this.cancelar();
        },

        cancelar() {
            this.$emit("close");
        },

    },
};
</script>
